import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive()

export abstract class SubscriptionBaseComponent implements OnDestroy {

    subscription: Subscription = new Subscription();

    constructor() {}

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

}
